// @flow

import _ from 'lodash';

export const pure = <T>(data: T) => _.pickBy(data, _.negate(v => _.isNil(v) || v === ''));
